export function areStringFieldsEmpty<T>(question: T) {
  return !Object.values(question).some((value) => typeof value === "string" && !!value);
}
